export enum ContentTypeLabel {
  word = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  excel = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  pdf = 'application/pdf'
}
